import React from 'react';
import styled, { keyframes } from 'styled-components';

// Animation keyframes for the silver folds
const moveDiagonal = keyframes`
  0% {
    transform: translate(-100px, -100px) rotate(45deg);
    opacity: 0;
  }
  10% {
    opacity: 0.8;
  }
  90% {
    opacity: 0.8;
  }
  100% {
    transform: translate(calc(100vw + 100px), calc(100vh + 100px)) rotate(45deg);
    opacity: 0;
  }
`;

const moveDiagonalReverse = keyframes`
  0% {
    transform: translate(calc(100vw + 100px), -100px) rotate(-45deg);
    opacity: 0;
  }
  10% {
    opacity: 0.6;
  }
  90% {
    opacity: 0.6;
  }
  100% {
    transform: translate(-100px, calc(100vh + 100px)) rotate(-45deg);
    opacity: 0;
  }
`;

const moveHorizontal = keyframes`
  0% {
    transform: translateX(-100px) rotate(0deg);
    opacity: 0;
  }
  10% {
    opacity: 0.7;
  }
  90% {
    opacity: 0.7;
  }
  100% {
    transform: translateX(calc(100vw + 100px)) rotate(0deg);
    opacity: 0;
  }
`;

const moveVertical = keyframes`
  0% {
    transform: translateY(-100px) rotate(90deg);
    opacity: 0;
  }
  10% {
    opacity: 0.5;
  }
  90% {
    opacity: 0.5;
  }
  100% {
    transform: translateY(calc(100vh + 100px)) rotate(90deg);
    opacity: 0;
  }
`;

const BackgroundContainer = styled.div`
  position: relative;
  width: 100%;
  background: #000000;
  overflow: hidden;
  min-height: 100vh;
  
  /* Add CSS animations for silver folds */
  &::before,
  &::after {
    content: '';
    position: absolute;
    width: 150px;
    height: 3px;
    background: linear-gradient(45deg, 
      rgba(192, 192, 192, 0.8) 0%, 
      rgba(255, 255, 255, 0.9) 50%, 
      rgba(192, 192, 192, 0.8) 100%);
    border-radius: 2px;
    box-shadow: 
      0 0 10px rgba(255, 255, 255, 0.3),
      inset 0 0 5px rgba(255, 255, 255, 0.2);
    z-index: 1;
    pointer-events: none;
  }
  
  &::before {
    animation: ${moveDiagonal} 8s linear infinite;
    animation-delay: 0s;
  }
  
  &::after {
    animation: ${moveDiagonalReverse} 10s linear infinite;
    animation-delay: 2s;
  }
`;

const ContentWrapper = styled.div`
  position: relative;
  z-index: 10;
  width: 100%;
`;

// Additional silver fold elements
const SilverFold1 = styled.div`
  position: absolute;
  width: 200px;
  height: 4px;
  background: linear-gradient(45deg, 
    rgba(192, 192, 192, 0.8) 0%, 
    rgba(255, 255, 255, 0.9) 50%, 
    rgba(192, 192, 192, 0.8) 100%);
  border-radius: 2px;
  box-shadow: 
    0 0 10px rgba(255, 255, 255, 0.3),
    inset 0 0 5px rgba(255, 255, 255, 0.2);
  animation: ${moveHorizontal} 12s linear infinite;
  animation-delay: 1s;
  z-index: 1;
  pointer-events: none;
`;

const SilverFold2 = styled.div`
  position: absolute;
  width: 120px;
  height: 2px;
  background: linear-gradient(45deg, 
    rgba(192, 192, 192, 0.8) 0%, 
    rgba(255, 255, 255, 0.9) 50%, 
    rgba(192, 192, 192, 0.8) 100%);
  border-radius: 2px;
  box-shadow: 
    0 0 10px rgba(255, 255, 255, 0.3),
    inset 0 0 5px rgba(255, 255, 255, 0.2);
  animation: ${moveVertical} 9s linear infinite;
  animation-delay: 3s;
  z-index: 1;
  pointer-events: none;
`;

const SilverFold3 = styled.div`
  position: absolute;
  width: 180px;
  height: 3px;
  background: linear-gradient(45deg, 
    rgba(192, 192, 192, 0.8) 0%, 
    rgba(255, 255, 255, 0.9) 50%, 
    rgba(192, 192, 192, 0.8) 100%);
  border-radius: 2px;
  box-shadow: 
    0 0 10px rgba(255, 255, 255, 0.3),
    inset 0 0 5px rgba(255, 255, 255, 0.2);
  animation: ${moveDiagonal} 11s linear infinite;
  animation-delay: 4s;
  z-index: 1;
  pointer-events: none;
`;

const SilverFold4 = styled.div`
  position: absolute;
  width: 100px;
  height: 2px;
  background: linear-gradient(45deg, 
    rgba(192, 192, 192, 0.8) 0%, 
    rgba(255, 255, 255, 0.9) 50%, 
    rgba(192, 192, 192, 0.8) 100%);
  border-radius: 2px;
  box-shadow: 
    0 0 10px rgba(255, 255, 255, 0.3),
    inset 0 0 5px rgba(255, 255, 255, 0.2);
  animation: ${moveDiagonalReverse} 7s linear infinite;
  animation-delay: 5s;
  z-index: 1;
  pointer-events: none;
`;

const AnimatedBackground = ({ children }) => {
  return (
    <BackgroundContainer>
      <SilverFold1 />
      <SilverFold2 />
      <SilverFold3 />
      <SilverFold4 />
      <ContentWrapper>
        {children}
      </ContentWrapper>
    </BackgroundContainer>
  );
};

export default AnimatedBackground;
